<template>
  <div class="qr-input">
    <div class='form-group' :class="[
        {'input-group': hasIcon},
        {'has-danger': error},
        {'focused': focused},
        {'has-label': label || $slots.label},
        {'has-success': valid === true},
        {'has-danger': valid === false},
        {'has-value': hasValue}
      ]">
      <slot name='label'>
        <label v-if='label' class='form-control-label' :class='labelClasses'>
          {{label}}
          <span v-if='required'>*</span>
        </label>
      </slot>
      <div v-if='iconLeft' class='input-group-prepend mr-0'>
        <span class='input-group-text' :class="addonLeftClasses">
          <i :style="`color: ${value == 'true' ? 'green' : 'red'};`" :class='iconLeft'></i>
        </span>
      </div>
      <slot v-bind='slotData'>
        <select :value='value' v-on='listeners' v-bind='$attrs' class='form-control' :class="[
            {'is-valid': valid === true},
            {'is-invalid': valid === false && value},
            inputClasses
          ]" aria-describedby='addon-right addon-left'>
          <option style="color:var(--text-inverse);" v-for="(op, i) in options" :key="i" :value="op.value">
            {{ op.desc }}
          </option>
        </select>
      </slot>

      <div v-if='addonRightIcon || $slots.addonRight' v-tooltip.top="addonRightTooltip" class='input-group-append ml-0'>
        <span class='input-group-text'>
          <slot name='addonRight'>
            <i @click="alterarTodosBotaoClickCheckbox()" :class='addonRightIcon'></i>
          </slot>
        </span>
      </div>

      <div v-if='secondaryButton && secondaryButtonIcon' class='input-group-append'>
        <span class='input-group-text secondaryButton' @click='secondaryButtonClick()'>
          <i :class='secondaryButtonIcon'></i>
        </span>
      </div>
    </div>
    <slot name='helpBlock'>
      <div class='text-danger invalid-feedback' style='display: block' :class="{'mt-2': hasIcon}" v-if='error'>
        <slot name='errorBlock'></slot>
      </div>
    </slot>
  </div>
</template>

<script>
export default {
  inheritAttrs: false,
  name: 'base-checkbox',
  props: {
    required: {
      type: Boolean,
      description: 'Whether input is required (adds an asterix *)'
    },
    secondaryButton: {
      type: Boolean,
      default: false
    },
    secondaryButtonIcon: {
      type: String
    },
    valid: {
      type: Boolean,
      description: 'Whether is valid',
      default: undefined
    },
    label: {
      type: String,
      description: 'Input label (text before input)'
    },
    error: {
      type: Boolean,
      description: 'Input error (below input)'
    },
    labelClasses: {
      type: String,
      description: 'Input label css classes'
    },
    addonLeftClasses: {
      type: String,
      description: 'Addon-left css classes'
    },
    inputClasses: {
      type: String,
      description: 'Input css classes'
    },
    value: {
      type: [String, Number],
      description: 'Input value',
      default: ''
    },
    addonRightIcon: {
      type: String,
      description: 'Addon right icon'
    },
    addonRightTooltip: {
      type: String,
      description: 'Addon right tooltip',
      default: null
    },
    addonLeftIcon: {
      type: String,
      description: 'Addont left icon'
    },
    addonLeftColor: {
      type: String,
      description: 'Addon left icon color'
    },
    mask: {
      type: [String, Array],
      description: 'Mask'
    },
    masked: {
      type: [Boolean],
      description: 'Mask'
    }
  },
  data () {
    return {
      focused: false,
      options: [{
        value: 'false',
        desc: 'Inativo'
      }, {
        value: 'true',
        desc: 'Ativo'
      }]
    }
  },
  computed: {
    listeners () {
      return {
        ...this.$listeners,
        input: this.updateValue,
        focus: this.onFocus,
        blur: this.onBlur
      }
    },
    slotData () {
      return {
        focused: this.focused,
        ...this.listeners
      }
    },
    hasIcon () {
      const { addonRight, addonLeft } = this.$slots
      return (
        addonRight !== undefined ||
        addonLeft !== undefined ||
        this.addonRightIcon !== undefined ||
        this.addonLeftIcon !== undefined
      )
    },
    hasValue () {
      if (this.value) {
        return true
      } else {
        return false
      }
    },
    iconLeft () {
      const icon = this.value == 'true'
        ? 'fas fa-check'
        : 'fas fa-times'
      return icon
    }
  },
  methods: {
    alterarTodosBotaoClickCheckbox() {
      this.$emit('alterarTodosBotaoClickCheckbox')
    },
    updateValue (evt) {
      let value = evt.target.value
      this.$emit('input', value)
    },
    onFocus (value) {
      this.focused = true
      this.$emit('focus', value)
    },
    onBlur (value) {
      this.focused = false
      this.$emit('blur', value)
    },
    secondaryButtonClick () {
      this.$emit('secondaryButtonClick')
    }
  }
}
</script>
